import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; //@ts-check

import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Icon from '../Icon';
import splitPath from '../../utils/pathUtil/splitPath';
import TextFormInput from '../../form/input/Text';
import Breadcrumb, { getBreadcrumbChildren } from './Breadcrumb';
import Styles from './styles';
import { HotKeys } from 'react-hotkeys';
var KEY_MAP = {
  MOVE_LEFT: ['left'],
  MOVE_RIGHT: ['right'],
  EDIT: ['ctrl+e']
};

var getBreadcrumbId = function getBreadcrumbId(path, idx) {
  return 'breadcrumb-' + path.split('/').join('-').split(' ').join('-').split('"').join('-').split("'").join('-') + '-' + idx;
};

var focusBreadcrumb = function focusBreadcrumb(path, idx) {
  var bEl = document.getElementById(getBreadcrumbId(path, idx));
  if (bEl) bEl.focus();
};

var blurBreadcrumb = function blurBreadcrumb(path, idx) {
  var bEl = document.getElementById(getBreadcrumbId(path, idx));
  if (bEl) bEl.blur();
};
/**
 * @param {import('./types').BreadcrumbsProps & import('@material-ui/core').WithStyles} props
 */


export function Breadcrumbs(props) {
  var path = props.path,
      onNavigateTo = props.onNavigateTo,
      darkColor = props.darkColor,
      classes = props.classes,
      typographyProps = props.typographyProps,
      render = props.render,
      editable = props.editable,
      rest = _objectWithoutProperties(props, ["path", "onNavigateTo", "darkColor", "classes", "typographyProps", "render", "editable"]);

  var _React$useState = React.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isEditing = _React$useState2[0],
      toggleEditing = _React$useState2[1];

  var segments = splitPath(path).map(function (s) {
    return {
      element: getBreadcrumbChildren(props, s),
      info: s
    };
  }).filter(function (s) {
    return s.element !== null;
  });

  var _React$useState3 = React.useState(segments.length - 2),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      crtFocusIdx = _React$useState4[0],
      setFocusIdx = _React$useState4[1];

  if (!path) return null;

  var focusBreadcrumbIdx = function focusBreadcrumbIdx(idx) {
    setFocusIdx(idx);
    focusBreadcrumb(path, idx);
  };

  var onBreadcrumbChange = function onBreadcrumbChange(newPath, segment) {
    blurBreadcrumb(path, segment.index);
    var nextIdx = segment.index - 1;
    if (nextIdx > -1) setFocusIdx(nextIdx);
    onNavigateTo(newPath, segment);
  };

  if (isEditing) {
    return React.createElement("div", rest, React.createElement(TextFormInput, {
      autoFocus: true,
      selectOnFocus: true,
      fullWidth: true,
      style: {
        height: 24
      },
      name: "Path",
      defaultValue: path,
      variant: "standard",
      onBlur: function onBlur() {
        toggleEditing(false);
      },
      onEnter: function onEnter(e) {
        toggleEditing(false);
        onNavigateTo(e.currentTarget.value, splitPath(path).pop());
        e.preventDefault();
      },
      onEscape: function onEscape(e) {
        toggleEditing(false);
        e.preventDefault();
      }
    }));
  }

  var keyHandlers = {
    MOVE_LEFT: function MOVE_LEFT() {
      var nextIdx = crtFocusIdx - 1;
      if (nextIdx < 0) return;
      focusBreadcrumbIdx(nextIdx);
    },
    MOVE_RIGHT: function MOVE_RIGHT() {
      var nextIdx = crtFocusIdx + 1;
      if (nextIdx > segments.length - 2) return;
      focusBreadcrumbIdx(nextIdx);
    },
    EDIT: function EDIT() {
      toggleEditing(true);
      return false;
    }
  };
  return React.createElement(HotKeys, {
    keyMap: KEY_MAP,
    handlers: keyHandlers,
    style: {
      outline: 'none'
    }
  }, React.createElement(Grid, Object.assign({
    container: true,
    direction: "row",
    justify: "flex-start",
    alignItems: "stretch"
  }, rest), segments.map(function (segment, idx) {
    return React.createElement(Grid, {
      item: true,
      key: idx
    }, React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "baseline"
    }, React.createElement(Grid, {
      item: true
    }, React.createElement(Breadcrumb, {
      id: getBreadcrumbId(path, idx),
      segment: segment.info,
      onNavigateTo: onBreadcrumbChange,
      typographyProps: typographyProps,
      tabIndex: idx === crtFocusIdx ? 0 : -1
    }, segment.element)), idx < segments.length - 1 && React.createElement(Grid, {
      item: true
    }, React.createElement(Icon, {
      type: "right",
      className: darkColor ? classes.arrowDark : classes.arrowLight
    }))));
  }), editable && React.createElement(Grid, {
    item: true,
    xs: true,
    style: {
      cursor: 'text'
    },
    onClick: function onClick() {
      return toggleEditing(true);
    }
  })));
}
Breadcrumbs.defaultProps = {
  darkColor: false,
  editable: false
};
var StyledBreadcrumbs = withStyles(Styles, {
  name: 'ECStyledBreadcrumbs'
})(Breadcrumbs);
StyledBreadcrumbs.displayName = 'Breadcrumbs';
export default StyledBreadcrumbs;